import React from 'react';
import Icon from '../../../components/AppIcon';

const ShippingStats = ({ orders, shipments, carriers }) => {
  const pendingShipments = orders?.filter(o => 
    !shipments?.some(s => s?.orderId === o?.id) && 
    (o?.status === 'confirmed' || o?.status === 'processing')
  )?.length || 0;

  const inTransit = shipments?.filter(s => s?.currentStatus === 'in_progress')?.length || 0;
  const delivered = shipments?.filter(s => s?.currentStatus === 'delivered')?.length || 0;
  const totalRevenue = orders?.reduce((sum, order) => sum + (order?.totalAmount || 0), 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Kargoya Hazır</span>
          <Icon name="Package" size={20} className="text-yellow-500" />
        </div>
        <p className="text-3xl font-bold text-foreground">{pendingShipments}</p>
        <p className="text-xs text-muted-foreground mt-1">Bekleyen sipariş</p>
      </div>

      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Kargoda</span>
          <Icon name="Truck" size={20} className="text-blue-500" />
        </div>
        <p className="text-3xl font-bold text-foreground">{inTransit}</p>
        <p className="text-xs text-muted-foreground mt-1">Yolda olan gönderi</p>
      </div>

      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Teslim Edildi</span>
          <Icon name="CheckCircle" size={20} className="text-green-500" />
        </div>
        <p className="text-3xl font-bold text-foreground">{delivered}</p>
        <p className="text-xs text-muted-foreground mt-1">Başarılı teslimat</p>
      </div>

      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Aktif Kargo</span>
          <Icon name="Building" size={20} className="text-purple-500" />
        </div>
        <p className="text-3xl font-bold text-foreground">{carriers?.length}</p>
        <p className="text-xs text-muted-foreground mt-1">Kargo firması</p>
      </div>
    </div>
  );
};

export default ShippingStats;